<script setup lang="ts">
import { RoleCatalogDto, UserCatalogDto } from '@/api/generator';
import { I18nKey } from '@/utils/typings';
import { mdiAccount, mdiAccountGroup } from '@mdi/js';
import { useTranslation } from 'i18next-vue';
import { computed } from 'vue';

const { t } = useTranslation();

const props = defineProps<{
  users?: UserCatalogDto[] | null;
  roles?: RoleCatalogDto[] | null;
}>();

const userNames = computed(() => props.users?.map((user) => user.fullName).join(', '));

const roleNames = computed(() =>
  props.roles
    ?.map((role) => (role.displayName ? t(role.displayName as I18nKey) : role.name))
    .join(', '),
);
</script>

<template>
  <div v-if="userNames" :class="{ 'mb-2': !!roleNames }">
    <v-icon :icon="mdiAccount" />
    {{ userNames }}
  </div>

  <div v-if="roleNames">
    <v-icon :icon="mdiAccountGroup" class="align-end" />
    {{ roleNames }}
  </div>
</template>
